var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 173.963,
    height: 48.5,
    viewBox: "0 0 173.963 48.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202",
    transform: "translate(-131.498 -225.159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M131.5,230.95h0v-5.791h5.212v5.791H141.2v4.222H136.71v7.034a2.177,2.177,0,0,0,2.389,2.461c.833,0,3.315.021,3.315.021v4.539H138.23c-3.872,0-6.731-2.425-6.731-6.732v-7.565h0Z",
    fill: "#e13505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M299.388,263.671h2.873l-.053-5.429h5.212l.053,5.429h4.488l-.053,4.218h-4.488v7.4a2.177,2.177,0,0,0,2.389,2.461c.833,0,3.315.021,3.315.021v4.539h-4.183c-3.872,0-6.732-2.426-6.732-6.733V267.89h-3.732Z",
    transform: "translate(-44.584 -8.833)",
    fill: "#e13505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M150.828,232.927h5.212v2.027l.218.073a6.436,6.436,0,0,1,4.959-2.461h.506v4.85h-.869a7.524,7.524,0,0,0-4.814,1.665v11.98h-5.212Z",
    transform: "translate(-5.161 -1.977)",
    fill: "#e13505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M182.063,234.158l.18-.108v-1.122h5.212v18.1h-5.212v-1.737l-.217-.073a7.04,7.04,0,0,1-5.321,2.172c-4.885,0-8.722-4.162-8.722-9.41a9.165,9.165,0,0,1,9.084-9.411A7.55,7.55,0,0,1,182.063,234.158Zm.18,10.5v-6.587a8.057,8.057,0,0,0-4.523-1.231c-2.5,0-4.525,2.135-4.525,5.14,0,2.968,2.027,5.139,4.525,5.139A4.751,4.751,0,0,0,182.244,244.654Z",
    transform: "translate(-9.742 -1.977)",
    fill: "#e13505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M200.719,232.927h5.212v2.063l.218.072a7.782,7.782,0,0,1,6.044-2.5c3.584,0,6.551,2.57,6.551,7.6v10.858h-5.212V240.455a3.278,3.278,0,0,0-3.511-3.619,5.372,5.372,0,0,0-4.09,1.593v12.6h-5.212Z",
    transform: "translate(-18.482 -1.977)",
    fill: "#e13505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M230.011,246.971h6.355c1.521,0,2.715-.435,2.715-1.484,0-.833-.507-1.411-2.823-1.882-3.474-.724-5.682-2.425-5.682-5.321,0-3.8,3.4-5.719,7.166-5.719h5.685l-.062,4.4s-3.74-.059-5.333-.059c-1.231,0-2.316.47-2.316,1.375,0,.723.4,1.339,2.823,1.81,3.548.723,5.72,2.171,5.72,5.248,0,4.089-3.656,5.7-7.565,5.7-2.135,0-6.645-.041-6.645-.041Z",
    transform: "translate(-26.304 -1.977)",
    fill: "#e13505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M164.007,265.649c5.755,0,10.026,4.162,10.026,9.41s-4.27,9.411-10.026,9.411c-5.791,0-10.026-4.163-10.026-9.411S158.216,265.649,164.007,265.649Zm0,14.55a5.15,5.15,0,1,0-4.814-5.14C159.193,278.064,161.183,280.2,164.007,280.2Z",
    transform: "translate(-6.003 -10.811)",
    fill: "#e13505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M186.11,266.011h5.212v2.063l.217.073a7.785,7.785,0,0,1,6.045-2.5c3.583,0,6.551,2.57,6.551,7.6v10.859h-5.212V273.539a3.279,3.279,0,0,0-3.511-3.619,5.374,5.374,0,0,0-4.09,1.592v12.6H186.11Z",
    transform: "translate(-14.582 -10.811)",
    fill: "#e13505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M216.758,266.011h5.212v2.063l.218.073a7.783,7.783,0,0,1,6.044-2.5c3.584,0,6.551,2.57,6.551,7.6v10.859h-5.212V273.539a3.278,3.278,0,0,0-3.511-3.619,5.375,5.375,0,0,0-4.09,1.592v12.6h-5.212Z",
    transform: "translate(-22.765 -10.811)",
    fill: "#e13505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M141.415,280.2a6.9,6.9,0,0,0,3.655-.833l1.013,4.09a9.6,9.6,0,1,1-4.668-17.807h5.077l-1.069,4.271h-4.008a5.141,5.141,0,0,0,0,10.279Z",
    transform: "translate(0 -10.811)",
    fill: "#e13505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M285.051,280.2a6.9,6.9,0,0,0,3.655-.833l1.014,4.09a9.6,9.6,0,1,1-4.669-17.807h5.1l-1.091,4.271h-4.008a5.141,5.141,0,0,0,0,10.279Z",
    transform: "translate(-38.352 -10.811)",
    fill: "#e13505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M331.863,265.649c5.755,0,10.026,4.162,10.026,9.41s-4.271,9.411-10.026,9.411c-5.791,0-10.026-4.163-10.026-9.411S326.072,265.649,331.863,265.649Zm0,14.55a5.15,5.15,0,1,0-4.814-5.14C327.049,278.064,329.039,280.2,331.863,280.2Z",
    transform: "translate(-50.822 -10.811)",
    fill: "#e13505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M353.966,266.011h5.212v2.027l.218.073a6.437,6.437,0,0,1,4.959-2.461h.507V270.5h-.869a7.522,7.522,0,0,0-4.814,1.665v11.98h-5.212Z",
    transform: "translate(-59.4 -10.811)",
    fill: "#e13505"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_293",
    "data-name": "Rectangle 293",
    width: 80.895,
    height: 2.84,
    transform: "translate(224.566 238.415)",
    fill: "#e13505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M264.107,274.408v2.171H251.258c.363,2.5,1.955,3.584,5.357,3.62a12.71,12.71,0,0,0,5.321-1.086l.9,3.8a13.016,13.016,0,0,1-6.225,1.557c-6.515,0-10.641-3.548-10.641-9.374a9.092,9.092,0,0,1,9.266-9.447C260.415,265.649,264,268.689,264.107,274.408Zm-12.7-1.23h7.456a3.184,3.184,0,0,0-3.439-3.257A3.738,3.738,0,0,0,251.4,273.178Z",
    transform: "translate(-30.566 -10.811)",
    fill: "#e13505"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6020f125874f9d6ff461878ad251948a.svg";
export { ForwardRef as ReactComponent };